import type { TFunction } from "i18next";

const defaults: Record<string, string> = {
    TEXT: "Text", CHOICE: "Choice", TRANSLATABLE_TEXT: "Translatable Text", CODE: "Code",
    INTEGER: "Number", DECIMAL: "Decimal", BOOLEAN: "Boolean",
    DATE: "Date", DATETIME: "Datetime", UUID: "UUID", REFERENCE: "Reference",
};

export const pickerTypeLabel = (t: TFunction, type: string): string =>
    String(t(`fluss.data.type.${type}`, { defaultValue: defaults[type] || type }));
